//require("@ckeditor/ckeditor5-build-classic/build/translations/ru.js");

//var ClassicEditor = require("./ckeditor");

require("./ckeditor")

var Inputmask = require('inputmask');
const { map } = require("lodash");
var selector = document.getElementById("inputPhone");
window.Handlebars = require('handlebars');

if (selector)
    Inputmask({ "mask": "+7 (999) 999-9999" }).mask(selector);
function makeid(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}
$(function () {

    $('#cp2, #cp3a, #cp3b').colorpicker();


    $('.news__row').each(function (i, item) {
        var $row = $(item);
        var maxHeightTitle = 0;
        var maxHeightText = 0;
        $row.find('.news__block').each(function (i, item) {
            var $block = $(item);
            if ($block.find('h5').height() > maxHeightTitle)
                maxHeightTitle = $block.find('h5').height();
            if ($block.find('p').height() > maxHeightText)
                maxHeightText = $block.find('p').height();
        });
        $row.find('.news__block').each(function (i, item) {
            var $block = $(item);
            $block.find('h5').css('height', maxHeightTitle);
            $block.find('p').css('height', maxHeightText);
        });
    });

    $('body').on('mouseover', '.notification__item', function (e) {
        var $this = $(this);
        if ($this.parents('li').hasClass('unread')) {
            $counter = $('#notifications').find('.counter')
            if ($counter.text() > 0) {
                $counter.text($counter.text() - 1)
            } else {
                $counter.remove()
            }
            $this.parents('li').removeClass('unread');
            $.ajax({
                url: $this.data('url'),
                type: 'POST',
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                success: function (response) {

                },
            });
        }
    });

    $('#notifications').on('show.bs.dropdown', function () {
        var $this = $(this);
        $.ajax({
            url: $this.data('notifications-url'),
            success: function (response) {
                $('.notifications__list').html(response);
            },
        });

    });

    $('#invites').on('show.bs.dropdown', function () {
        var $this = $(this);
        $.ajax({
            url: $this.data('invites-url'),
            success: function (response) {
                $('.invites__list').html(response);
            },
        });

    });

    $('body').on('click', '.invite__action', function (e) {
        e.preventDefault()
        var $this = $(this)
        $.ajax({
            url: $this.data('url'),
            success: function (response) {
                $counter = $('#invites').find('.counterInvites')
                if ($counter.text() > 0) {
                    $counter.text($counter.text() - 1)
                } else {
                    $counter.remove()
                }
                $this.parents('.invite__block').remove();
            },
        });
    })

    function toggleCounter($this) {
        if ($this.hasClass('active')) {
            $this.removeClass('active');
            $this.find('span').text(parseInt($this.find('span').text()) - 1);
        } else {
            $this.addClass('active');
            $this.find('span').text(parseInt($this.find('span').text()) + 1);
        }
    }
    $('body').on('click', '.metric', function () {
        var $this = $(this);
        if ($this.data('url')) {
            toggleCounter($this);
            $.ajax({
                url: $this.data('url'),
                type: 'POST',
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                error: function (response) {
                    toggleCounter($this);
                },
            });
        }
    })

    window.autosize($('.comment__textarea'));
    window.autosize($('.post__textarea'));

    $('body').on('click', '.more__comments, .more__posts', function (e) {
        e.preventDefault();
        var $this = $(this);
        $this.addClass('disabled');
        $this.prepend('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> ');
        $.ajax({
            url: $this.attr('href'),
            type: 'GET',
            success: function (json) {
                $this.replaceWith($(json).find('.ajaxResponse').html());
            },
            error: function () {
                $this.removeClass('disabled');
                $this.find('i').remove();
                $this.prepend('<i class="fa fa-cross"></i> ');
                setTimeout(function () {
                    $this.find('i').remove();
                }, 1000);

            }
        })
    })

    $('body').on('click', '.replay', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $comment__block = $this.parents('.comments__block');

        $comment__block.find('input[name=parent_id]').val($this.data('id'));
        $comment__block.find('.send__comment__block').find('.title').append('<span class="label__comment">Ответ ' + $this.data('name') + ' <i class="fa fa-close remove__replay"></i></span>');
        $('html, body').stop().animate({
            scrollTop: $comment__block.find('.send__comment__block').offset().top
        }, 1000);
    })

    $('body').on('click', '.remove__replay', function () {
        var $this = $(this);
        var $comment__block = $this.parents('.comments__block');
        $comment__block.find('input[name=parent_id]').val('');
        $this.parents('span').remove();
    })

    // $.ajaxSetup({
    //     headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
    // });
    $('body').on('change', '.active__marathon', function (e) {
        var $this = $(this);
        $this.prop('disabled', true);
        var $form = $this.parents('form');
        $('.active__marathon:checked').trigger('click');
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (response) {
                $this.prop('disabled', false);
            },
            error: function () {
                $this.prop('disabled', false);
                if ($this.prop('checked')) {
                    $this.prop('checked', false);
                } else {
                    $this.prop('checked', true);
                }
            }
        });

    })

    $('body').on('change', '.active__captain', function (e) {
        var $this = $(this);
        var $form = $this.parents('form');
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            beforeSend: function () {
                $this.prop('disabled', true);
            },
            success: function (response) {
                $this.prop('disabled', false);
            },
            error: function () {
                $this.prop('disabled', false);
                if ($this.prop('checked')) {
                    $this.prop('checked', false);
                } else {
                    $this.prop('checked', true);
                }
            }
        });


    })

    $('body').on('click', '.btn-danger', function (e) {
        if (!$(this).hasClass('not-confirm'))
            return confirm("Вы уверены?");
    });
    function guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4();
    }
    $('body').on('click', '.add_theses_input', function (e) {
        e.preventDefault();
        var $this = $(this);
        var id = guid();
        $this.parents('.button').before('<div class="container input__block"><div class="row"><div class="col-md-11">\n' +
            '   <div class="form-label-group">\n' +
            '        <input id="inputKey_theses_' + id + '" class=" form-control" placeholder="Тезис" name="key_theses[]" type="text" required="true">\n' +
            '        <label for="inputKey_theses_' + id + '">Тезис *</label>\n' +
            '    </div>\n' +
            '</div>\n' +
            '<div class="col-md-1 pL-0">\n' +
            '<a href="" class="btn btn-danger trash__button not-confirm"><i class="c-1000 ti-trash"></i></a></div></div>')
    });

    $('body').on('click', '.trash__button', function (e) {
        e.preventDefault();
        if (confirm('Вы уверены?')) {
            $(this).parents('.input__block').remove();
        }
    });
    $('body').on('submit', '.news__delete', function (e) {
        e.preventDefault();
        if (confirm('Вы уверены?')) {
            var $this = $(this),
                tr = $this.parents('tr');
            tr.css('display', 'none');
            $.ajax({
                url: $this.attr('action'),
                type: $this.attr('method'),
                data: $this.serialize(),
                success: function () {
                    tr.remove();
                },
                error: function () {
                    tr.css('display', 'inherit')
                }
            })
        } else {
            return false;
        }
    })

    if (typeof window.sortableURL != 'undefinde') {
        $('.dd-dictionary').nestable({ maxDepth: 1 }).on('change', function (e) {
            $.ajax({
                url: window.sortableURL,
                type: 'POST',
                data: { data: $(e.target).nestable('serialize') },
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                success: function (json) {
                },
                error: function (error) {
                    alert(error.statusText);
                }
            });
        });
    }

    if (typeof window.sortURL != 'undefinde') {
        $('.dd-articles').nestable({ maxDepth: 1 }).on('change', function (e) {
            $.ajax({
                url: window.sortableURL,
                type: 'POST',
                data: { data: $(e.target).nestable('serialize') },
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                success: function (json) {
                },
                error: function (error) {
                    alert(error.statusText);
                }
            });
        });
    }

    $('body').on('click', '.delete_report_field', function (e) {
        e.preventDefault();
        if (confirm("Вы уверены?")) {
            var $this = $(this);
            var parent = $this.parents('.report_field');
            parent.remove();
        }
    })

    $('body').on('click', '.add_report_field', function (e) {
        e.preventDefault();
        var $this = $(this);
        var id = makeid(5);
        var idOne = makeid(5);
        var idTwo = makeid(5);
        var idThree = makeid(5);
        $this.parents('.add_report_field_block').before('<div class="bgc-white p-20 bd report_field">' +
            '<div class="row">' +
            '<div class="col-md-3">' +
            '<div class="form-label-group mB-0">' +
            '<input id="input' + idOne + '" class=" form-control" placeholder="Название *" required="" name="report_fields[' + id + '][title]" type="text">' +
            '<label for="input' + idOne + '">Название *</label>' +
            '</div>' +
            '</div>' +
            '<div class="col-md-3">' +
            '<div class="form-label-group mB-0">' +
            '<input id="input' + idTwo + '" class=" form-control" placeholder="Название на латинице *" required="" name="report_fields[' + id + '][slug]" type="text">' +
            '<label for="input' + idTwo + '">Название на латинице *</label>' +
            '</div>' +
            '</div>' +
            '<div class="col-md-3">' +
            '<div class="form-group mB-0">' +
            '<select class="form-control selectpicker h-100" required="" name="report_fields[' + id + '][type]">' +
            '<option selected="selected" value="">Тип поля *</option>' +
            '<option value="text">Текстовое поле</option>' +
            '<option value="format_text">Текстовое поле с форматированием</option>' +
            '<option value="upload_file">Загрузка файлв</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '<div class="col-md-2">' +
            '<div class="form-label-group mB-0">' +
            '<input id="input' + idThree + '" class=" form-control" placeholder="Сортировка *" required="" name="report_fields[' + id + '][sort]" type="text">' +
            '<label for="input' + idThree + '">Сортировка *</label>' +
            '</div>' +
            '</div>' +
            '<div class="col-md-1">' +
            '<a class="btn btn-lg btn-danger btn-block c-white not-confirm delete_report_field"><i class="c-light-white-500 ti-trash"></i></a>' +
            '</div>' +
            '</div>' +
            '</div>');
        $('.selectpicker').selectpicker();
    })

    $('body').on('change mousemove', '[name=rating]', function () {
        var $this = $(this);
        $this.parents('.rating__block').find('.rating').html($this.val());

    });

    $("body").on("change", ".custom-file-input", function () {
        var fileName = $(this).val().split("\\").pop();
        $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
    });


    if (typeof window.uploadUrl != 'underfind') {
        if ($('#text-editor').length) {
            BalloonEditor
                .create(document.querySelector('#text-editor'), {
                    language: 'ru',
                    mediaEmbed: {
                        previewsInData: true
                    },
                    image: {
                        // You need to configure the image toolbar, too, so it uses the new style buttons.
                        toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],

                        styles: [
                            // This option is equal to a situation where no style is applied.
                            'full',

                            // This represents an image aligned to the left.
                            'alignLeft',

                            // This represents an image aligned to the right.
                            'alignRight'
                        ]
                    },
                    ckfinder: {
                        uploadUrl: window.uploadUrl
                    }
                    // cloudServices: {
                    //     tokenUrl: 'https://35645.cke-cs.com/token/dev/KX5s7jK1CrzjxUd9DfigZxtBNkHyPa9ectdEDw8jzVJFOmP3InVjDgnOIgTU',
                    //     uploadUrl: 'https://35645.cke-cs.com/easyimage/upload/'
                    // }
                })
                .then(editor => {
                    window.editor = editor;
                    //editor.isReadOnly=true;
                })
                .catch(err => {
                    console.error(err.stack);
                });
            // $('body').on('click','.save__help__page',function(e){
            //     e.preventDefault();
            //     var text=window.editor.getData();
            //     var $form = $(this).parents('form');
            //     $form.find('[name=text]').text(text);
            //     $form.submit();
            // })
        }

        if ($('#inputTextClassic').length) {
            var editor = ClassicEditor
                .create(document.querySelector('#inputTextClassic'), {
                    toolbar: {
                        items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'imageUpload',
                            'blockQuote',
                            'insertTable',
                            'mediaEmbed',
                            'htmlEmbed',
                            'undo',
                            'redo'
                        ]
                    },
                    language: 'ru',
                    mediaEmbed: {
                        previewsInData: true
                    },

                    image: {
                        // You need to configure the image toolbar, too, so it uses the new style buttons.
                        toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],

                        styles: [
                            // This option is equal to a situation where no style is applied.
                            'full',

                            // This represents an image aligned to the left.
                            'alignLeft',

                            // This represents an image aligned to the right.
                            'alignRight'
                        ]
                    },
                    ckfinder: {
                        uploadUrl: window.uploadUrl
                    }
                    // cloudServices: {
                    //     tokenUrl: 'https://35645.cke-cs.com/token/dev/KX5s7jK1CrzjxUd9DfigZxtBNkHyPa9ectdEDw8jzVJFOmP3InVjDgnOIgTU',
                    //     uploadUrl: 'https://35645.cke-cs.com/easyimage/upload/'
                    // }
                })
                .then(editor => {
                    window.editor = editor;
                    //editor.isReadOnly=true;
                })
                .catch(err => {
                    console.error(err.stack);
                });

        }
        if ($('#inputTextClassic2').length) {
            var editor = ClassicEditor
                .create(document.querySelector('#inputTextClassic2'), {
                    toolbar: {
                        items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'imageUpload',
                            'blockQuote',
                            'insertTable',
                            'mediaEmbed',
                            'htmlEmbed',
                            'undo',
                            'redo'
                        ]
                    },
                    language: 'ru',
                    mediaEmbed: {
                        previewsInData: true
                    },
                    image: {
                        // You need to configure the image toolbar, too, so it uses the new style buttons.
                        toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],

                        styles: [
                            // This option is equal to a situation where no style is applied.
                            'full',

                            // This represents an image aligned to the left.
                            'alignLeft',

                            // This represents an image aligned to the right.
                            'alignRight'
                        ]
                    },
                    ckfinder: {
                        uploadUrl: window.uploadUrl
                    }
                    // cloudServices: {
                    //     tokenUrl: 'https://35645.cke-cs.com/token/dev/KX5s7jK1CrzjxUd9DfigZxtBNkHyPa9ectdEDw8jzVJFOmP3InVjDgnOIgTU',
                    //     uploadUrl: 'https://35645.cke-cs.com/easyimage/upload/'
                    // }
                })
                .then(editor => {
                    window.editor = editor;
                    //editor.isReadOnly=true;
                })
                .catch(err => {
                    console.error(err.stack);
                });

        }
    }
    let maxHeight = 0;
    Array.from(document.getElementsByClassName('section-card__header-line')).forEach((el) => {
        if (el.clientHeight > maxHeight) { maxHeight = el.clientHeight }
    });
    Array.from(document.getElementsByClassName('section-card__header-line')).forEach((el) => {
        el.style.height = maxHeight + 'px';
    });
    maxHeight = 0
    Array.from(document.getElementsByClassName('section-card')).forEach((el) => {
        if (el.clientHeight > maxHeight) { maxHeight = el.clientHeight }
    });
    Array.from(document.getElementsByClassName('section-card')).forEach((el) => {
        el.style.height = maxHeight + 'px';
    });
});